"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var _headerCellFactory = require("../header-cell/headerCellFactory");
var _loadingCellFactory = require("../loading-cell/loadingCellFactory");
var _FormattedAmount = require("../../../formatted-amount/FormattedAmount");
var _exchange = require("../../../../assets/icons/exchange.svg");
var _amountCellModule = _interopRequireDefault(require("./amount-cell.module.scss"));
var _Tooltip = require("../../../tooltip/Tooltip");
var _classnames = _interopRequireDefault(require("classnames"));
var AmountCell = function AmountCell(_ref) {
  var data = _ref.data,
    className = _ref.className;
  var _ref2 = data || {},
    currency = _ref2.currency,
    valueInCents = _ref2.valueInCents,
    exchangeCurrency = _ref2.exchangeCurrency,
    exchangeValueInCents = _ref2.exchangeValueInCents,
    tooltipLabel = _ref2.tooltipLabel;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("td", {
    className: (0, _classnames.default)(_amountCellModule.default['amount-cell'], className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _amountCellModule.default['amount-cell__container']
  }, exchangeCurrency && exchangeCurrency !== currency || tooltipLabel ? /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: _amountCellModule.default['amount-cell__tooltip']
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _amountCellModule.default['amount-cell__tooltip-label']
    }, tooltipLabel || t('amountCell.converted')), exchangeCurrency !== undefined && exchangeValueInCents !== undefined && /*#__PURE__*/_react.default.createElement(_FormattedAmount.FormattedAmount, {
      valueInCents: exchangeValueInCents,
      currency: exchangeCurrency,
      currencyClassName: _amountCellModule.default['amount-cell__amount-currency']
    })),
    position: "bottom",
    variant: "light"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _amountCellModule.default['amount-cell__icon-container']
  }, /*#__PURE__*/_react.default.createElement(_exchange.ReactComponent, {
    "data-testid": "exchange-icon"
  }))) : null, /*#__PURE__*/_react.default.createElement(_FormattedAmount.FormattedAmount, {
    valueInCents: valueInCents,
    currency: currency,
    currencyClassName: _amountCellModule.default['amount-cell__amount-currency']
  })));
};
exports.AmountCell = AmountCell;
AmountCell.Header = (0, _headerCellFactory.headerCellFactory)(_amountCellModule.default['amount-cell']);
AmountCell.Loading = (0, _loadingCellFactory.loadingCellFactory)(_amountCellModule.default['amount-cell']);